var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRobot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 219,
    viewBox: "0 0 227 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.661 124.881L191.681 127.302L212.276 178.185L218.255 175.764L197.661 124.881Z",
    fill: "#F264E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M197.661 124.881L191.681 127.302L212.276 178.185L218.255 175.764L197.661 124.881Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M197.661 124.881L191.681 127.302L212.276 178.185L218.255 175.764L197.661 124.881Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M197.661 124.881L191.681 127.302L212.276 178.185L218.255 175.764L197.661 124.881Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3507 121.155C95.3625 121.155 104.289 112.229 104.289 101.217C104.289 90.2051 95.3625 81.2783 84.3507 81.2783C73.3389 81.2783 64.4121 90.2051 64.4121 101.217C64.4121 112.229 73.3389 121.155 84.3507 121.155Z",
    fill: "url(#paint0_radial_203_57)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M187.562 130.774C187.562 169.595 164.457 201.028 135.957 201.028C107.456 201.028 84.3508 169.595 84.3508 130.774C84.3508 91.9521 107.456 80.3408 135.957 80.3408C164.457 80.3408 187.562 91.9521 187.562 130.774Z",
    fill: "url(#paint1_radial_203_57)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M187.562 130.774C187.562 169.595 164.457 201.028 135.957 201.028C107.456 201.028 84.3508 169.595 84.3508 130.774C84.3508 91.9521 107.456 80.3408 135.957 80.3408C164.457 80.3408 187.562 91.9521 187.562 130.774Z",
    fill: "url(#paint2_linear_203_57)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M135.956 121.508C155.389 121.508 171.142 112.423 171.142 101.217C171.142 90.0111 155.389 80.9268 135.956 80.9268C116.524 80.9268 100.771 90.0111 100.771 101.217C100.771 112.423 116.524 121.508 135.956 121.508Z",
    fill: "#393091"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M110.974 92.1863C124.697 84.2109 147.098 84.2109 160.821 92.1863C166.45 95.4703 169.852 99.5753 170.79 103.915C172.197 97.816 168.913 91.4826 160.821 86.7911C147.098 78.8157 124.697 78.8157 110.974 86.7911C102.882 91.4826 99.5976 97.816 101.005 103.915C101.943 99.6926 105.345 95.4703 110.974 92.1863Z",
    fill: "#453C9E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2581 52.8963L101.592 41.8714C105.345 38.001 108.394 32.8404 109.802 27.6798L116.252 16.5377L106.987 11.2598C106.635 11.0252 106.4 10.9079 106.048 10.6734C103.468 9.38322 99.9496 9.73508 96.0791 11.9635C87.8691 16.6549 81.1838 28.2662 81.1838 37.6491C81.1838 42.3405 82.8258 45.7418 85.5234 47.2665L95.2581 52.8963Z",
    fill: "url(#paint3_radial_203_57)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M116.128 40.6495C121.925 30.6084 121.941 19.7643 116.163 16.4283C110.386 13.0924 101.002 18.528 95.2046 28.5691C89.4072 38.6101 89.3914 49.4543 95.1692 52.7902C100.947 56.1261 110.331 50.6906 116.128 40.6495Z",
    fill: "#BCBEFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M137.95 105.323C167.034 105.323 190.611 81.7454 190.611 52.6613C190.611 23.5773 167.034 0 137.95 0C108.866 0 85.2888 23.5773 85.2888 52.6613C85.2888 81.7454 108.866 105.323 137.95 105.323Z",
    fill: "url(#paint4_radial_203_57)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M137.95 105.323C167.034 105.323 190.611 81.7454 190.611 52.6613C190.611 23.5773 167.034 0 137.95 0C108.866 0 85.2888 23.5773 85.2888 52.6613C85.2888 81.7454 108.866 105.323 137.95 105.323Z",
    fill: "url(#paint5_linear_203_57)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M167.389 88.3152L173.722 77.2903C177.475 73.4199 180.525 68.2593 181.932 63.0988L188.383 51.9566L179.117 46.6787C178.765 46.4442 178.531 46.3269 178.179 46.0923C175.481 44.8022 172.08 45.154 168.21 47.3825C160 52.0739 153.314 63.6852 153.314 73.068C153.314 77.7595 154.956 81.1608 157.654 82.6855L167.389 88.3152Z",
    fill: "url(#paint6_radial_203_57)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M188.305 76.1046C194.103 66.0635 194.118 55.2193 188.341 51.8834C182.563 48.5475 173.179 53.9831 167.382 64.0241C161.584 74.0652 161.569 84.9094 167.346 88.2453C173.124 91.5812 182.508 86.1456 188.305 76.1046Z",
    fill: "#BCBEFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M163.753 78.6983C163.753 69.1982 170.439 57.7042 178.649 53.0128C181.463 51.3708 184.161 50.7843 186.389 51.0189C184.044 50.4325 181.112 51.0189 177.945 52.8955C169.735 57.5869 163.05 69.1982 163.05 78.5811C163.05 84.7972 165.864 88.5503 170.204 89.1368C166.216 88.3158 163.753 84.5626 163.753 78.6983Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M185.359 74.4038C189.505 67.2236 189.5 59.46 185.349 57.0634C181.198 54.6667 174.472 58.5445 170.327 65.7247C166.181 72.9049 166.186 80.6685 170.337 83.0652C174.488 85.4618 181.214 81.584 185.359 74.4038Z",
    fill: "#393091"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M183.926 56.4141C184.982 57.7042 185.686 59.6981 185.686 62.1611C185.686 68.9636 180.877 77.1736 175.013 80.5749C172.784 81.8651 170.673 82.2169 168.914 81.8651C170.79 84.0935 174.074 84.4454 177.828 82.3342C183.692 78.9329 188.501 70.7229 188.501 63.9204C188.501 59.6981 186.741 57.1178 183.926 56.4141Z",
    fill: "#453C9E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M115.412 87.4774C122.229 84.6396 123.78 72.789 118.876 61.0083C113.972 49.2276 104.471 41.978 97.6533 44.8158C90.836 47.6536 89.285 59.5042 94.1889 71.2849C99.0929 83.0656 108.595 90.3152 115.412 87.4774Z",
    fill: "#393091"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M114.728 68.6115C114.258 72.3647 111.444 73.5375 108.394 71.3091C105.345 68.9634 103.351 64.0374 103.82 60.2842C104.289 56.5311 107.104 55.3582 110.153 57.5867C113.086 59.9324 115.197 64.8584 114.728 68.6115Z",
    fill: "#F264E0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M114.728 68.6115C114.258 72.3647 111.444 73.5375 108.394 71.3091C105.345 68.9634 103.351 64.0374 103.82 60.2842C104.289 56.5311 107.104 55.3582 110.153 57.5867C113.086 59.9324 115.197 64.8584 114.728 68.6115Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M114.728 68.6115C114.258 72.3647 111.444 73.5375 108.394 71.3091C105.345 68.9634 103.351 64.0374 103.82 60.2842C104.289 56.5311 107.104 55.3582 110.153 57.5867C113.086 59.9324 115.197 64.8584 114.728 68.6115Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M114.728 68.6115C114.258 72.3647 111.444 73.5375 108.394 71.3091C105.345 68.9634 103.351 64.0374 103.82 60.2842C104.289 56.5311 107.104 55.3582 110.153 57.5867C113.086 59.9324 115.197 64.8584 114.728 68.6115Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M108.042 83.3893C99.7151 77.0558 94.0854 63.568 95.4928 53.1295C96.0793 48.9073 97.7213 45.8578 99.9497 44.2158C95.6101 44.5677 92.3261 48.3208 91.5051 54.6543C90.215 64.9754 95.8447 78.5806 104.055 84.914C108.981 88.6671 113.672 89.019 117.073 86.556C114.376 86.7906 111.209 85.735 108.042 83.3893Z",
    fill: "#453C9E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M104.758 84.5617C96.4311 78.2283 90.8014 64.7404 92.2088 54.302C92.7953 49.4933 94.7891 46.2093 97.604 44.6846C94.4373 45.9747 92.0916 49.376 91.5051 54.5366C90.215 64.8577 95.8447 78.4629 104.055 84.7963C108.512 88.1976 112.851 88.784 116.018 87.142C112.968 88.4322 108.981 87.7285 104.758 84.5617Z",
    fill: "#F264E0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M104.758 84.5617C96.4311 78.2283 90.8014 64.7404 92.2088 54.302C92.7953 49.4933 94.7891 46.2093 97.604 44.6846C94.4373 45.9747 92.0916 49.376 91.5051 54.5366C90.215 64.8577 95.8447 78.4629 104.055 84.7963C108.512 88.1976 112.851 88.784 116.018 87.142C112.968 88.4322 108.981 87.7285 104.758 84.5617Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M104.758 84.5617C96.4311 78.2283 90.8014 64.7404 92.2088 54.302C92.7953 49.4933 94.7891 46.2093 97.604 44.6846C94.4373 45.9747 92.0916 49.376 91.5051 54.5366C90.215 64.8577 95.8447 78.4629 104.055 84.7963C108.512 88.1976 112.851 88.784 116.018 87.142C112.968 88.4322 108.981 87.7285 104.758 84.5617Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M104.758 84.5617C96.4311 78.2283 90.8014 64.7404 92.2088 54.302C92.7953 49.4933 94.7891 46.2093 97.604 44.6846C94.4373 45.9747 92.0916 49.376 91.5051 54.5366C90.215 64.8577 95.8447 78.4629 104.055 84.7963C108.512 88.1976 112.851 88.784 116.018 87.142C112.968 88.4322 108.981 87.7285 104.758 84.5617Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M194.717 146.021C205.728 146.021 214.655 137.094 214.655 126.082C214.655 115.07 205.728 106.144 194.717 106.144C183.705 106.144 174.778 115.07 174.778 126.082C174.778 137.094 183.705 146.021 194.717 146.021Z",
    fill: "url(#paint7_radial_203_57)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M194.717 146.021C205.728 146.021 214.655 137.094 214.655 126.082C214.655 115.07 205.728 106.144 194.717 106.144C183.705 106.144 174.778 115.07 174.778 126.082C174.778 137.094 183.705 146.021 194.717 146.021Z",
    fill: "url(#paint8_linear_203_57)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M226.501 192.349C225.328 201.849 217.001 219.793 209.378 218.972C201.754 218.034 197.884 198.565 198.939 189.065C200.112 179.564 207.149 172.645 214.773 173.466C222.396 174.404 227.674 182.848 226.501 192.349Z",
    fill: "url(#paint9_radial_203_57)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M226.501 192.349C225.328 201.849 217.001 219.793 209.378 218.972C201.754 218.034 197.884 198.565 198.939 189.065C200.112 179.564 207.149 172.645 214.773 173.466C222.396 174.404 227.674 182.848 226.501 192.349Z",
    fill: "url(#paint10_linear_203_57)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3376 131.243C30.1647 131.243 29.1092 130.657 28.5227 129.484C27.7017 127.959 28.2882 125.965 29.9302 125.144L71.2148 103.564C72.7395 102.743 74.7333 103.329 75.5543 104.971C76.3753 106.496 75.7889 108.49 74.1469 109.311L32.8623 130.891C32.3932 131.126 31.924 131.243 31.3376 131.243Z",
    fill: "#F264E0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3376 131.243C30.1647 131.243 29.1092 130.657 28.5227 129.484C27.7017 127.959 28.2882 125.965 29.9302 125.144L71.2148 103.564C72.7395 102.743 74.7333 103.329 75.5543 104.971C76.3753 106.496 75.7889 108.49 74.1469 109.311L32.8623 130.891C32.3932 131.126 31.924 131.243 31.3376 131.243Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3376 131.243C30.1647 131.243 29.1092 130.657 28.5227 129.484C27.7017 127.959 28.2882 125.965 29.9302 125.144L71.2148 103.564C72.7395 102.743 74.7333 103.329 75.5543 104.971C76.3753 106.496 75.7889 108.49 74.1469 109.311L32.8623 130.891C32.3932 131.126 31.924 131.243 31.3376 131.243Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3376 131.243C30.1647 131.243 29.1092 130.657 28.5227 129.484C27.7017 127.959 28.2882 125.965 29.9302 125.144L71.2148 103.564C72.7395 102.743 74.7333 103.329 75.5543 104.971C76.3753 106.496 75.7889 108.49 74.1469 109.311L32.8623 130.891C32.3932 131.126 31.924 131.243 31.3376 131.243Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1586 143.206C23.714 147.781 4.24457 151.416 0.608706 144.731C-3.02715 138.046 10.4607 123.502 18.9053 118.928C27.3499 114.354 37.0846 115.996 40.7205 122.799C44.3563 129.484 40.4859 138.632 32.1586 143.206Z",
    fill: "url(#paint11_radial_203_57)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1586 143.206C23.714 147.781 4.24457 151.416 0.608706 144.731C-3.02715 138.046 10.4607 123.502 18.9053 118.928C27.3499 114.354 37.0846 115.996 40.7205 122.799C44.3563 129.484 40.4859 138.632 32.1586 143.206Z",
    fill: "url(#paint12_linear_203_57)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_203_57",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.935 37.3245) rotate(11.1976) scale(115.424)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_203_57",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(166.384 120.254) scale(88.7232 120.776)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_203_57",
    x1: 135.923,
    y1: 201.066,
    x2: 135.923,
    y2: 80.3404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F264E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00713563,
    stopColor: "#EF63DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1379,
    stopColor: "#BF56CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2725,
    stopColor: "#964AB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4089,
    stopColor: "#7441AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5478,
    stopColor: "#5A399F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6901,
    stopColor: "#483497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8379,
    stopColor: "#3D3193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_203_57",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(83.9418 -29.0774) scale(62.4797)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_203_57",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(170.831 44.8535) scale(88.9953)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_203_57",
    x1: 130.642,
    y1: 104.802,
    x2: 145.3,
    y2: 0.505972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F264E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00713563,
    stopColor: "#EF63DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1379,
    stopColor: "#BF56CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2725,
    stopColor: "#964AB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4089,
    stopColor: "#7441AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5478,
    stopColor: "#5A399F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6901,
    stopColor: "#483497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8379,
    stopColor: "#3D3193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_203_57",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(170.118 43.9058) scale(42.2644)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_203_57",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(206.513 113.087) rotate(11.1976) scale(41.7168)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_203_57",
    x1: 178.489,
    y1: 137.89,
    x2: 210.842,
    y2: 114.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F264E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00713563,
    stopColor: "#EF63DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1379,
    stopColor: "#BF56CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2725,
    stopColor: "#964AB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4089,
    stopColor: "#7441AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5478,
    stopColor: "#5A399F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6901,
    stopColor: "#483497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8379,
    stopColor: "#3D3193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_203_57",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(231.749 176.593) rotate(6.80285) scale(35.4642 58.4195)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_203_57",
    x1: 198.396,
    y1: 194.619,
    x2: 225.898,
    y2: 197.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F264E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00713563,
    stopColor: "#EF63DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1379,
    stopColor: "#BF56CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2725,
    stopColor: "#964AB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4089,
    stopColor: "#7441AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5478,
    stopColor: "#5A399F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6901,
    stopColor: "#483497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8379,
    stopColor: "#3D3193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_203_57",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.8056 119.507) rotate(61.2705) scale(35.4644 58.4206)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_203_57",
    x1: 40.351,
    y1: 133.211,
    x2: 9.75036,
    y2: 125.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F264E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00713563,
    stopColor: "#EF63DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1379,
    stopColor: "#BF56CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2725,
    stopColor: "#964AB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4089,
    stopColor: "#7441AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5478,
    stopColor: "#5A399F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6901,
    stopColor: "#483497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8379,
    stopColor: "#3D3193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.967c85c06cf9a1e7ef250fc6019e80be.svg";
export { ForwardRef as ReactComponent };